import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../services/authService';

const getAuthenticatedHomePath = () => {
  const currentUser = authService.getCurrentUser();

  if (currentUser?.user_type === 'admin') {
    return '/admin/dashboard';
  }

  return '/research';
};

const PublicRoute = ({ children }) => {
  if (authService.isAuthenticated()) {
    return <Navigate to={getAuthenticatedHomePath()} replace />;
  }

  return children;
};

export default PublicRoute;
